import { Skeleton } from 'aui';
import classNames from 'clsx';
import React from 'react';

type IProps = React.HTMLAttributes<HTMLDivElement>;
const SpinBlock: React.FC<IProps> = (props) => {
  const { className } = props;
  return (
    <div {...props} className={classNames('flex items-center justify-center p-12', className)}>
      <Skeleton active />
    </div>
  );
};

export default SpinBlock;
